import styled from '@emotion/styled'

import { colors, typography } from '../constants'
import { Text } from '../typography'
import { RadioInput } from './styles'

// For RadioGroup

export const Container = styled.div`
  font-family: ${typography.fontFamily.ui};
`
interface IRadioButtonsContainerProps {
  inline: boolean
}

export const RadioButtonsContainer = styled.div<IRadioButtonsContainerProps>`
  display: flex;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
  margin-top: 17px;
`
export const ValidationHint = styled.div`
  color: ${colors.text.error};
  font-size: ${typography.fontSize.hint};
`

// For Radio Buttons

interface IRadioLabelProps {
  inline: boolean
  disabled: boolean
}

export const RadioLabel = styled(Text.withComponent('label'))<IRadioLabelProps>`
  color: ${({ disabled }) => (disabled ? colors.text.disabled : 'inherit')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  margin-right: ${({ inline }) => (inline ? '40px' : '0')};
`

export const StyledRadioInput = styled(RadioInput)`
  margin-bottom: 17px;
  margin-right: 10px;
`
